import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { motion } from 'framer-motion';
import { BookOpen, Clock, CreditCard, GraduationCap, Users, Zap } from 'lucide-react';

const faqs = [
  {
    question: 'Ako prebiehajú kurzy?',
    answer: 'Kurzy prebiehajú online formou interaktívnych webinárov. Kombinujeme teoretický výklad s praktickými ukážkami a cvičeniami. Účastníci majú možnosť aktívne sa zapájať a klásť otázky počas celého trvania kurzu.',
    icon: BookOpen,
  },
  {
    question: 'Aká je dĺžka kurzu?',
    answer: 'Štandardné kurzy trvajú 2 až 3 hodiny. Firemné školenia môžu mať flexibilnú dĺžku podľa vašich špecifických požiadaviek.',
    icon: Clock,
  },
  {
    question: 'Pre koho sú kurzy určené?',
    answer: 'Začiatočnícke (Basic a Basic+) kurzy sú vhodné pre absolútne každého – od študentov a seniorov až po rodičov, učiteľov, zamestnancov či manažérov. Nepotrebujete žiadne technické znalosti ani predchádzajúce skúsenosti s AI, všetko vám bude ozrejmené počas trvania kurzu. Oboznámite sa s najnovšími trendami a informáciami o AI. Kurzy sú navrhnuté tak, aby boli zrozumiteľné a prínosné pre všetky vekové kategórie a profesie. Pokročilé kurzy sú ideálne pre tých, ktorí základy už ovládajú a chcú prehĺbiť svoje znalosti v oblasti implementácie AI technológií. Ukážeme si ako implementovať lokálne AI modely, rozbehnúť no-code automatizácie a jednoduché aplikácie.',
    icon: Users,
  },
  {
    question: 'Aké sú možnosti platby?',
    answer: 'Pre všetky kurzy ponúkame zľavu Early Bird (-20%) pri skorej registrácii. Akceptujeme len platby kartou pomocou aplikácie Stripe. Individuálne kurzy a workshopy je možné uhradiť aj pomocou faktúry a bankového prevodu. Pre informácie nás kontaktujte na dole uvedenom telefónnom čísle alebo e-mailom.',
    icon: CreditCard,
  }
];

export default function FAQ() {
  return (
    <section id="faq" className="py-24 bg-gray-50 dark:bg-gray-900">
      <div className="container px-4 mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-3xl mx-auto text-center mb-16"
        >
          <h2 className="text-3xl font-bold mb-4">Často kladené otázky</h2>
          <p className="text-gray-600 dark:text-gray-300">
            Našli ste odpoveď na svoju otázku? Ak nie, neváhajte nás kontaktovať.
          </p>
        </motion.div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => {
              const Icon = faq.icon;
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                >
                  <AccordionItem value={`item-${index}`} className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                    <AccordionTrigger className="px-6 hover:no-underline">
                      <div className="flex items-center gap-3">
                        <div className="p-2 rounded-lg bg-blue-50 dark:bg-blue-900/20">
                          <Icon className="w-5 h-5 text-blue-600 dark:text-blue-400" />
                        </div>
                        <span className="text-lg font-semibold">{faq.question}</span>
                      </div>
                    </AccordionTrigger>
                    <AccordionContent className="px-6 pb-4 text-gray-600 dark:text-gray-300">
                      <div className="pl-12">{faq.answer}</div>
                    </AccordionContent>
                  </AccordionItem>
                </motion.div>
              );
            })}
          </Accordion>
        </div>
      </div>
    </section>
  );
}